var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "page",
      staticClass: "page index-page f-2",
      on: { scroll: _vm.handlePageScroll },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "multi-bubble bubble-confirm as-flex flex-vertical main-center cross-center f-2",
          on: {
            click: function ($event) {
              return _vm.changeMultiStatus(true)
            },
          },
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.currrentChosenMovies.length === 0
                  ? "多选"
                  : _vm.currrentChosenMovies.length + "部"
              )
            ),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("对比")]),
        ]
      ),
      _vm._v(" "),
      _vm.isMulti
        ? _c(
            "div",
            {
              staticClass:
                "multi-bubble bubble-cancel as-flex flex-vertical main-center cross-center f-2",
              on: {
                click: function ($event) {
                  return _vm.changeMultiStatus(false)
                },
              },
            },
            [
              _c("span", [_vm._v("取消")]),
              _vm._v(" "),
              _c("span", [_vm._v("对比")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "search-bar as-flex main-end cross-center" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c("el-input", {
              attrs: {
                placeholder: "搜索影片名",
                "prefix-icon": "el-icon-search",
              },
              model: {
                value: _vm.searchInfo,
                callback: function ($$v) {
                  _vm.searchInfo = $$v
                },
                expression: "searchInfo",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "filterBox", class: ["filter-box", "is-fixed"] },
        [
          _c("filterBox", {
            attrs: {
              filterTypesModel: _vm.filterTypes,
              currentFilterFlag: _vm.currentFilter,
            },
            on: { executeFilter: _vm.recieveFilterChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "subFilterBox",
          class: [
            "sub-filter",
            "as-flex",
            "main-start",
            "cross-center",
            "f-2",
            true ? "is-fixed" : "",
          ],
          style: { top: true ? _vm.subFilterBoxFixedEdge + "px" : 0 + "px" },
        },
        [
          _c(
            "div",
            {
              class: [
                "ordered-item",
                "time-ordered",
                _vm.currentFilter.orderby === "" ? "is-selected" : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.validateChangeFilter("orderby", "")
                },
              },
            },
            [_vm._v("时间排序")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                "ordered-item",
                "box-ordered",
                _vm.currentFilter.orderby === "box" ? "is-selected" : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.validateChangeFilter("orderby", "box")
                },
              },
            },
            [_vm._v("票房排序")]
          ),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              class: [
                "ordered-item",
                _vm.currentFilter.orderby && _vm.currentFilter.orderby !== "box"
                  ? "is-selected"
                  : "",
              ],
              attrs: { trigger: "click" },
            },
            [
              _c("span", { staticClass: "el-dropdown-link" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.currentFilter.orderby &&
                        _vm.currentFilter.orderby !== "box"
                        ? _vm.orderbyMapping.find(function (item) {
                            return item.id === _vm.currentFilter.orderby
                          }).value
                        : "指标排序"
                    ) +
                    "\n        "
                ),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _vm._l(_vm.orderbyMapping, function (item) {
                    return [
                      _c(
                        "el-dropdown-item",
                        {
                          key: item.id,
                          attrs: {
                            disabled: _vm.disabledOrders.includes(item.id),
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.validateChangeFilter(
                                    "orderby",
                                    item.id
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.value))]
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              class: ["ordered-item", "cycle-filter"],
              attrs: { trigger: "click" },
            },
            [
              _c("span", { staticClass: "el-dropdown-link" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.currentFilter.cycle
                        ? _vm.cycleMapping.find(function (item) {
                            return item.id === _vm.currentFilter.cycle
                          }).value
                        : "周期数据(最新)"
                    ) +
                    "\n        "
                ),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.validateChangeFilter("cycle", "")
                          },
                        },
                      },
                      [_vm._v("周期数据(最新)")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.cycleMapping, function (item) {
                    return [
                      _c(
                        "el-dropdown-item",
                        {
                          key: item.id,
                          attrs: {
                            disabled: _vm.disabledCycles.includes(item.id),
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.validateChangeFilter(
                                    "cycle",
                                    item.id
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.value))]
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen.lock",
              value: _vm.isLoadingMovie,
              expression: "isLoadingMovie",
              modifiers: { fullscreen: true, lock: true },
            },
          ],
          staticClass: "search-list",
        },
        [
          _vm._l(_vm.movieList, function (item) {
            return [
              _c(
                "div",
                {
                  key: "movie_" + item.movie.id,
                  staticClass: "movie-box-container",
                  on: {
                    click: function ($event) {
                      _vm.isMulti
                        ? _vm.toggleCurrentChosenMovies(item.movie.id)
                        : _vm.setMainMovie(item.movie.id)
                    },
                  },
                },
                [
                  _c("movieBox", {
                    attrs: {
                      type: _vm.isMulti ? "multi" : "single",
                      chosen:
                        _vm.currrentChosenMovies.indexOf(item.movie.id) >= 0,
                      movieInfo: item,
                    },
                  }),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }